import { TableRowCellWrapper } from './styled-components.js'

const TableRowCell = ({ ...props }) => {
  return <TableRowCellWrapper {...props} />
}

export default TableRowCell
